import { Routes } from '@angular/router';
import { StudySubjectsComponent } from './study-subjects.component';
import { SponsorSubjectComponent } from './sponsor-subject.component';
import { LabTestsChartComponent } from '../../subjects/lab-tests-chart.component';
import { LabTestsGridComponent } from '../../subjects/lab-tests-grid.component';
import { sponsorDefaultActivityHandler } from '../../activities/navigation-activity/handlers/sponsor/sponsor-default-activity-handler';
import { navigationActivity } from '../../activities/navigation-activity/navigation-activity-resolver';
import { PageTitle } from '../../core/page-title';
import { SponsorStudySiteIdentitiesResolver } from '../lab-results/sponsor-study-site-identities-resolver';
import { routeData, routeParams } from '../../shared/route-helpers';
import { SponsorSubjectIdentitiesResolver } from './sponsor-subject-identities-resolver';

export const sponsorSubjectsRoutes: Routes = [
    {
        path: 'subjects',
        data: {
            title: PageTitle.getSponsorTitle('Subjects'),
            ...sponsorDefaultActivityHandler('View Study Subjects'),
        },
         resolve: {
            ...navigationActivity,
            [routeData.sponsorSubjectIdentities]: SponsorSubjectIdentitiesResolver
         },
        children: [
            {
                path: '',
                resolve: {
                    [routeData.studySiteIdentities]: SponsorStudySiteIdentitiesResolver,
                },
                component: StudySubjectsComponent,
                pathMatch: 'full'
            },
            {
                path: `:${routeParams.zcSubjectId}`,
                component: SponsorSubjectComponent,
                children: [
                    {
                        path: 'lab-tests-grid',
                        data: { ...sponsorDefaultActivityHandler('View Subjects - Table') },
                        resolve: { ...navigationActivity },
                        component: LabTestsGridComponent
                    },
                    {
                        path: 'lab-tests-chart',
                        data: { ...sponsorDefaultActivityHandler('View Subjects - Chart') },
                        resolve: { ...navigationActivity },
                        component: LabTestsChartComponent
                    },
                    { path: '**', redirectTo: 'lab-tests-grid', pathMatch: 'full' }
                ]
            }
        ]
    }
];